import { gsap } from "gsap";

// gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin, TextPlugin);

const circleSlider = () => {
    console.log("init circleSlider");
    var frameCount = 55;
    var sprite = document.querySelector('#sprite');
    var flowerTl = gsap.timeline({});
    flowerTl.pause();
    flowerTl.fromTo("#sprite",
        { y: 0 }, {
        y: () => -(sprite.clientHeight / frameCount) * (frameCount - 1),
        ease: "steps(" + (frameCount - 1) + ")",
        duration: 7,
        repeat: -1,
        yoyo: true,          
    });

    console.log("add eventlistener");
    
    window.addEventListener("resize", () => {
        flowerTl.invalidate();
        flowerTl.time(0);
        flowerTl.pause();
    });

    // let screenLog = document.querySelector("#logger");
    let flowercontainer = document.querySelector("#flowercontainer");

    var olddeg;
    var startdeg;
    var diffdeg = 0;
    var currentVal = 0;

    var mdown = false;
    flowercontainer.addEventListener("mousedown", setStart);
    flowercontainer.addEventListener("touchstart", setStart);
    
    flowercontainer.addEventListener("mouseup", setEnd);
    flowercontainer.addEventListener("touchend", setEnd)
    flowercontainer.addEventListener("touchcancel", setEnd)

    flowercontainer.addEventListener("mousemove", (e) => {
        console.log("easteregg");
        easterEgg(e.clientX, e.clientY);
    });
    flowercontainer.addEventListener("touchmove", (e) => {
        console.log("easteregg");
        easterEgg(e.touches[0].clientX, e.touches[0].clientY);
    }); 


    function setStart(e) {
        mdown = true;
    }

    function setEnd(e) {
        mdown = false;
        startdeg = undefined;
        flowerTl.pause();
    }

    function easterEgg (clientx, clienty) {    
        var h = flowercontainer.clientHeight;
        var x1 = flowercontainer.clientWidth / 2;
        var y1 = h / 2;

        var rect = document.querySelector("#flowercontainer").getBoundingClientRect();

        var y2 = clienty - rect.top;
        var x2 = clientx - rect.left;
        var deg;
        if (mdown) {
            y2 = h - y2;
            var dy = y2 - y1;
            var dx = x2 - x1;

            //check if mouse is exactly on coordinate cross
            if (dx == 0) {
                if (dy >= 0) {
                    deg = 90;
                } else {
                    deg = 270;
                }
            } else if (dy == 0) {
                if (dx >= 0) {
                    deg = 0;
                } else {
                    deg = 180;
                }
            } else if (dx > 0) {
                if (dy > 0) {
                    //Quadrant I
                     console.log("Quadrant I");
                    deg = Math.atan(dy / dx) * 180 / Math.PI;
                } else {
                    //Quadrant IV
                    // console.log("Quadrant IV");
                    deg = 360 + Math.atan(dy / dx) * 180 / Math.PI;
                }
            } else {
                if (dy < 0) {
                    //Quadrant III
                    // console.log("Quadrant III");
                    deg = 180 + Math.atan(dy / dx) * 180 / Math.PI;
                } else {
                    //Quadrant II
                    // console.log("Quadrant II");
                    deg = 180 + Math.atan(dy / dx) * 180 / Math.PI;
                }
            }

            if (startdeg) {

                if (olddeg < 10 && deg > 350) {
                    olddeg += 360;
                } else if (olddeg > 350 && deg < 10) {
                    olddeg -= 360;
                }

                diffdeg = olddeg - deg;


                currentVal += diffdeg;
                var currentTime = Math.abs(7 * currentVal / 360);
                flowerTl.time(currentTime);

            } else {
                startdeg = deg;
            }

            // screenLog.innerText = `
    
            //         olddeg: ${olddeg}
            //         deg: ${deg}   
            //         diffdeg: ${diffdeg}
            //         currentVal: ${currentVal}          
            //         currentTime: ${currentTime}
                    
            // `;

            olddeg = deg;
        } else {
            startdeg = undefined;
            flowerTl.pause();
        }
    };


    

}

export default circleSlider;